export default "__VITE_ASSET__f542903a__"